import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { useComposableDashboardsFiltersContext } from '../../../../features/analyticsPage/hooks/useComposableDashboardsFiltersContext';
import { filterByWidget } from '../../../../features/clientDetails/components/notes/helper/notesHelper';
import CountWithTextCard from '../../../analytics/components/countWithTextCard';
import usePostgreNoteWidgetsData from '../../DerivedCharts/ClientNotes/hooks/usePostgreNoteWidgetsData';
import { ClientNotesWidget } from '../../DerivedCharts/helper';
import { IClientNotesDTO } from '../jobs/types/postgreJobsDTO';
import { IClientNotesWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

import { renderClientNotesCountCell } from './utils/clientNotesDrillDownHelper';
import { defaultClientNotesWidgetData } from './utils/clientNotesHelper';

const ClientNotesMetricChartPostgre = ({ query, title, widgetName }: IClientNotesWidgetProp) => {
  const { widgetData } = usePostgreNoteWidgetsData<IClientNotesDTO>(
    query,
    defaultClientNotesWidgetData
  );

  const { restructuredFilters } = useComposableDashboardsFiltersContext();

  const getNoteCountByType = (noteType: string, data: any) => {
    const typeMap: Record<string, number | undefined> = {
      Total: data?.totalNotes,
      Phone: data?.totalPhoneNotes,
      SMS: data?.totalSMSNotes,
      Email: data?.totalEmailNotes,
      Other: data?.totalOtherNotes,
    };
    return typeMap[noteType] ?? 0;
  };

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {widgetName == ClientNotesWidget.METRIC_TOTAL_TYPE_WISE ? (
        ['Total', 'Phone', 'SMS', 'Email', 'Other'].map((noteType) => (
          <Grid item key={noteType} xs={1} ml={10}>
            <CountWithTextCard
              variant="h4"
              count={
                renderClientNotesCountCell(
                  { value: getNoteCountByType(noteType, widgetData.totalCountByType) },
                  [['NOTE_TYPE', noteType]],
                  restructuredFilters,
                  query
                ) as any
              }
              fullHeight
              text={noteType}
              textVariant="caption"
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard
            variant="h3"
            count={
              renderClientNotesCountCell(
                { value: widgetData.count ?? 0 },
                filterByWidget(widgetName),
                restructuredFilters,
                query
              ) as any
            }
            fullHeight
            text=""
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ClientNotesMetricChartPostgre;
